import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import { signOut } from "firebase/auth";
import auth from "../firebase.init";
import Header from "./Header";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    var sideBar = document.getElementById("mobile-nav");
    var openSidebar = document.getElementById("openSideBar");
    var closeSidebar = document.getElementById("closeSideBar");

    if (isMenuOpen === true) {
      sideBar.classList.add("translate-x-0");
      closeSidebar.classList.remove("hidden");
      openSidebar.classList.add("hidden");
    } else {
      sideBar.classList.remove("translate-x-0");
      closeSidebar.classList.add("hidden");
      openSidebar.classList.remove("hidden");
    }
  }, [isMenuOpen]);

  const handleSignOut = () => {
    signOut(auth);
    navigate("/login");
  };
  return (
    <div class="max-w-[1740px] m-auto h-screen bg-[#f7fafc] relative">
      <div>
        <div class="flex flex-no-wrap ">
          {/* <!-- Sidebar starts --> */}

          <div class="w-72 h-screen absolute sm:relative bg-[#131d55] shadow  flex-col justify-between hidden sm:flex">
            <div class=" ">
              <div class="h-16 mt-4 w-full flex items-center px-9">
                <img
                  src="https://pd.daffodilvarsity.edu.bd/web/image/website/1/logo/Smart%20Edu%20-%20DIU?unique=9ba175f"
                  alt=""
                />
              </div>
              {/* Web View */}
              <ul class="mt-8 space-y-3 font-thin font-poppins ">
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/booking"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-8 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 !fill-[#7d84ab] group-hover:!fill-[#dee2ec]"
                      viewBox="0 96 960 960"
                    >
                      <path d="M510 486V216h330v270H510ZM120 606V216h330v390H120Zm390 330V546h330v390H510Zm-390 0V666h330v270H120Zm60-390h210V276H180v270Zm390 330h210V606H570v270Zm0-450h210V276H570v150ZM180 876h210V726H180v150Zm210-330Zm180-120Zm0 180ZM390 726Z" />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Booking
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/routes"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-8 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 !fill-[#7d84ab] group-hover:!fill-[#dee2ec]"
                      viewBox="0 96 960 960"
                    >
                      <path d="M249 936q-13 0-23-7.5T216 909v-84q-29-16-42.5-46T160 715V318q0-74 76.5-108T481 176q166 0 242.5 34T800 318v397q0 34-13.5 64T744 825v84q0 12-10 19.5t-23 7.5h-19q-14 0-24-7.5T658 909v-55H302v55q0 12-10 19.5t-24 7.5h-19Zm232-644h259-520 261Zm177 293H220h520-82Zm-438-60h520V352H220v173Zm106 219q23 0 39-16t16-39q0-23-16-39t-39-16q-23 0-39 16t-16 39q0 23 16 39t39 16Zm308 0q23 0 39-16t16-39q0-23-16-39t-39-16q-23 0-39 16t-16 39q0 23 16 39t39 16ZM220 292h520q-24-26-92-41t-167-15q-118 0-181 13.5T220 292Zm82 502h356q35 0 58.5-27t23.5-62V585H220v120q0 35 23.5 62t58.5 27Z" />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Routes
                    </span>
                  </Link>
                </li>

                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/profile"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-8 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Profile
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/contact"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-8 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                      />
                    </svg>

                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Contact
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/about"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-8 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-stack"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <polyline points="12 4 4 8 12 12 20 8 12 4" />
                      <polyline points="4 12 12 16 20 12" />
                      <polyline points="4 16 12 20 20 16" />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      About Us
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <button
                    onClick={handleSignOut}
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-8 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                      />
                    </svg>

                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Sign Out
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Mobile View */}
          <div
            class="w-64 z-40 absolute bg-[#131d55] shadow md:h-full flex-col justify-between sm:hidden transition-transform -translate-x-full duration-500 ease-in-out"
            id="mobile-nav"
          >
            <button
              id="openSideBar"
              class="h-10 w-10 bg-[#131d55] absolute right-0 mt-16 -mr-10 flex items-center shadow rounded-tr rounded-br justify-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 rounded focus:ring-gray-800"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-adjustments"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#FFFFFF"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <circle cx="6" cy="10" r="2" />
                <line x1="6" y1="4" x2="6" y2="8" />
                <line x1="6" y1="12" x2="6" y2="20" />
                <circle cx="12" cy="16" r="2" />
                <line x1="12" y1="4" x2="12" y2="14" />
                <line x1="12" y1="18" x2="12" y2="20" />
                <circle cx="18" cy="7" r="2" />
                <line x1="18" y1="4" x2="18" y2="5" />
                <line x1="18" y1="9" x2="18" y2="20" />
              </svg>
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              id="closeSideBar"
              class=" h-10 w-10 bg-[#131d55]  absolute right-0 mt-16 -mr-10 flex items-center shadow rounded-tr rounded-br justify-center cursor-pointer text-white'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-x"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#FFFFFF"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <div class=" h-screen">
              <div class="h-16 mt-4 px-10 w-full flex items-center">
                <svg
                  aria-label="Ripples. Logo"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  width="144"
                  height="30"
                  viewBox="0 0 144 30"
                >
                  <path
                    fill="#5F7DF2"
                    d="M80.544 9.48c1.177 0 2.194.306 3.053.92.86.614 1.513 1.45 1.962 2.507.448 1.058.673 2.247.673 3.568 0 1.303-.233 2.473-.699 3.51-.465 1.037-1.136 1.851-2.012 2.444-.876.592-1.885.888-3.028.888-1.405 0-2.704-.554-3.897-1.663v4.279h2.64v3.072h-9.14v-3.072h2.26V12.78H70.45V9.657h6.145v1.663l.209-.21c1.123-1.087 2.369-1.63 3.74-1.63zm17.675 0c1.176 0 2.194.306 3.053.92.859.614 1.513 1.45 1.961 2.507.449 1.058.673 2.247.673 3.568 0 1.303-.233 2.473-.698 3.51-.466 1.037-1.136 1.851-2.012 2.444-.876.592-1.886.888-3.028.888-1.405 0-2.704-.554-3.898-1.663v4.279h2.64v3.072h-9.14v-3.072h2.26V12.78h-1.904V9.657h6.144v1.663l.21-.21c1.122-1.087 2.368-1.63 3.739-1.63zM24.973 1c1.13 0 2.123.433 2.842 1.133 0 .004 0 .008.034.012 1.54 1.515 1.54 3.962-.034 5.472-.035.029-.069.058-.069.089-.719.65-1.712 1.05-2.773 1.05-.719 0-1.37.061-1.985.184-2.363.474-3.8 1.86-4.28 4.13-.114.489-.18 1.02-.2 1.59l-.003.176.001-.034.002.034c.022.505-.058 1.014-.239 1.495l-.076.182.064-.157c.106-.28.18-.575.217-.881l.008-.084-.026.195c-.286 1.797-1.858 3.188-3.754 3.282l-.204.005h-.103l-.103.002h-.034c-.65.012-1.232.072-1.78.181-2.328.473-3.765 1.863-4.279 4.139-.082.417-.142.863-.163 1.339l-.008.362v.23c0 2.02-1.603 3.681-3.661 3.861L4.16 29l-.48-.01c-.958-.073-1.849-.485-2.499-1.113-1.522-1.464-1.573-3.808-.152-5.33l.152-.154.103-.12c.719-.636 1.677-1.026 2.704-1.026.754 0 1.404-.062 2.02-.184 2.362-.475 3.8-1.86 4.28-4.126.136-.587.17-1.235.17-1.942 0-.991.411-1.896 1.027-2.583.069-.047.137-.097.172-.15.068-.051.102-.104.17-.159.633-.564 1.498-.925 2.408-.978l.229-.007h.034c.068 0 .171.003.274.009.616-.014 1.198-.074 1.746-.18 2.328-.474 3.766-1.863 4.279-4.135.082-.44.142-.912.163-1.418l.008-.385v-.132c0-2.138 1.78-3.872 4.005-3.877zm-.886 10c1.065 0 1.998.408 2.697 1.073.022.011.03.024.042.036l.025.017v.015c1.532 1.524 1.532 3.996 0 5.52-.034.03-.067.06-.067.09-.7.655-1.665 1.056-2.697 1.056-.7 0-1.332.062-1.932.186-2.298.477-3.696 1.873-4.163 4.157-.133.591-.2 1.242-.2 1.95 0 1.036-.399 1.975-1.032 2.674l-.1.084c-.676.679-1.551 1.055-2.441 1.13l-.223.012-.366-.006c-.633-.043-1.3-.254-1.865-.632-.156-.096-.296-.201-.432-.315l-.2-.177v-.012c-.734-.735-1.133-1.72-1.133-2.757 0-2.078 1.656-3.793 3.698-3.899l.198-.005h.133c.666-.007 1.266-.069 1.832-.185 2.265-.476 3.663-1.874 4.163-4.161.08-.442.139-.916.159-1.424l.008-.387v-.136c0-2.153 1.731-3.899 3.896-3.904zm3.882 11.025c1.375 1.367 1.375 3.583 0 4.95s-3.586 1.367-4.96 0c-1.345-1.367-1.345-3.583 0-4.95 1.374-1.367 3.585-1.367 4.96 0zm94.655-12.672c1.405 0 2.628.323 3.669.97 1.041.648 1.843 1.566 2.406 2.756.563 1.189.852 2.57.87 4.145h-9.954l.03.251c.132.906.476 1.633 1.03 2.18.605.596 1.386.895 2.343.895 1.058 0 2.09-.525 3.097-1.574l3.301 1.066-.203.291c-.69.947-1.524 1.67-2.501 2.166-1.075.545-2.349.818-3.821.818-1.473 0-2.774-.277-3.904-.831-1.13-.555-2.006-1.34-2.628-2.355-.622-1.016-.933-2.21-.933-3.58 0-1.354.324-2.582.971-3.682s1.523-1.961 2.628-2.583c1.104-.622 2.304-.933 3.599-.933zm13.955.126c1.202 0 2.314.216 3.339.648v-.47h3.034v3.91h-3.034l-.045-.137c-.317-.848-1.275-1.272-2.875-1.272-1.21 0-1.816.339-1.816 1.016 0 .296.161.516.483.66.321.144.791.262 1.409.355 1.735.22 3.102.536 4.1.946 1 .41 1.697.919 2.095 1.524.398.605.597 1.339.597 2.202 0 1.405-.48 2.5-1.441 3.282-.96.783-2.266 1.174-3.917 1.174-1.608 0-2.7-.321-3.275-.964V23h-3.098v-4.596h3.098l.032.187c.116.547.412.984.888 1.311.53.364 1.183.546 1.962.546.762 0 1.324-.087 1.688-.26.364-.174.546-.476.546-.908 0-.296-.076-.527-.228-.692-.153-.165-.447-.31-.883-.438-.435-.127-1.102-.27-2-.431-1.997-.313-3.433-.82-4.31-1.517-.875-.699-1.313-1.64-1.313-2.825 0-1.21.455-2.162 1.365-2.856.91-.695 2.11-1.042 3.599-1.042zm-69.164.178v10.27h1.98V23h-8.24v-3.072h2.032V12.78h-2.031V9.657h6.259zm-16.85-5.789l.37.005c1.94.05 3.473.494 4.6 1.335 1.198.892 1.797 2.185 1.797 3.878 0 1.168-.273 2.15-.819 2.945-.546.796-1.373 1.443-2.482 1.943l3.085 5.776h2.476V23h-5.827l-4.317-8.366h-2.183v5.116h2.4V23H39.646v-3.25h2.628V7.118h-2.628v-3.25h10.918zm61.329 0v16.06h1.892V23h-8.24v-3.072h2.082v-13h-2.082v-3.06h6.348zm-32.683 9.04c-.812 0-1.462.317-1.949.951-.486.635-.73 1.49-.73 2.565 0 1.007.252 1.847.756 2.52.503.673 1.161 1.01 1.974 1.01.838 0 1.481-.312 1.93-.934.448-.622.672-1.504.672-2.647 0-1.092-.228-1.942-.685-2.552-.457-.61-1.113-.914-1.968-.914zm17.675 0c-.813 0-1.463.317-1.95.951-.486.635-.73 1.49-.73 2.565 0 1.007.253 1.847.756 2.52.504.673 1.162 1.01 1.974 1.01.838 0 1.481-.312 1.93-.934.449-.622.673-1.504.673-2.647 0-1.092-.229-1.942-.686-2.552-.457-.61-1.113-.914-1.967-.914zM14.1 0C16.267 0 18 1.743 18 3.894v.01c0 2.155-1.733 3.903-3.9 3.903-4.166 0-6.3 2.133-6.3 6.293 0 2.103-1.667 3.817-3.734 3.9l-.5-.009c-.933-.075-1.8-.49-2.433-1.121C.4 16.134 0 15.143 0 14.1c0-2.144 1.733-3.903 3.9-3.903 4.166 0 6.3-2.133 6.3-6.294C10.2 1.751 11.934.005 14.1 0zm108.32 12.184c-.76 0-1.372.22-1.834.66-.46.44-.75 1.113-.87 2.018h5.561c-.118-.795-.442-1.44-.97-1.936-.53-.495-1.158-.742-1.886-.742zM49.525 7.118h-2.26v4.444h1.829c2.023 0 3.034-.754 3.034-2.26 0-.728-.233-1.274-.698-1.638-.466-.364-1.1-.546-1.905-.546zm15.821-3.593c.635 0 1.183.231 1.644.692.462.462.692 1.01.692 1.644 0 .677-.23 1.238-.692 1.682-.46.445-1.009.667-1.644.667-.643 0-1.195-.23-1.656-.692-.462-.461-.692-1.013-.692-1.657 0-.634.23-1.182.692-1.644.46-.461 1.013-.692 1.656-.692zM5.991 1.171c1.345 1.563 1.345 4.095 0 5.658-1.374 1.561-3.585 1.561-4.96 0-1.375-1.563-1.375-4.095 0-5.658 1.375-1.561 3.586-1.561 4.96 0z"
                  />
                </svg>
              </div>
              <ul
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                class="mt-8 space-y-3 font-thin font-poppins"
              >
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/booking"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-10 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 !fill-[#7d84ab] group-hover:!fill-[#dee2ec]"
                      viewBox="0 96 960 960"
                    >
                      <path d="M510 486V216h330v270H510ZM120 606V216h330v390H120Zm390 330V546h330v390H510Zm-390 0V666h330v270H120Zm60-390h210V276H180v270Zm390 330h210V606H570v270Zm0-450h210V276H570v150ZM180 876h210V726H180v150Zm210-330Zm180-120Zm0 180ZM390 726Z" />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Booking
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/dashboard"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-10 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 !fill-[#7d84ab] group-hover:!fill-[#dee2ec]"
                      viewBox="0 96 960 960"
                    >
                      <path d="M249 936q-13 0-23-7.5T216 909v-84q-29-16-42.5-46T160 715V318q0-74 76.5-108T481 176q166 0 242.5 34T800 318v397q0 34-13.5 64T744 825v84q0 12-10 19.5t-23 7.5h-19q-14 0-24-7.5T658 909v-55H302v55q0 12-10 19.5t-24 7.5h-19Zm232-644h259-520 261Zm177 293H220h520-82Zm-438-60h520V352H220v173Zm106 219q23 0 39-16t16-39q0-23-16-39t-39-16q-23 0-39 16t-16 39q0 23 16 39t39 16Zm308 0q23 0 39-16t16-39q0-23-16-39t-39-16q-23 0-39 16t-16 39q0 23 16 39t39 16ZM220 292h520q-24-26-92-41t-167-15q-118 0-181 13.5T220 292Zm82 502h356q35 0 58.5-27t23.5-62V585H220v120q0 35 23.5 62t58.5 27Z" />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Buses
                    </span>
                  </Link>
                </li>

                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/profile"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-10 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Profile
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/contact"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-10 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                      />
                    </svg>

                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Contact
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <Link
                    to="/about"
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-10 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-stack"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <polyline points="12 4 4 8 12 12 20 8 12 4" />
                      <polyline points="4 12 12 16 20 12" />
                      <polyline points="4 16 12 20 20 16" />
                    </svg>
                    <span class="text-sm ml-2 tracking-wide font-thin">
                      About Us
                    </span>
                  </Link>
                </li>
                <li class="flex w-full justify-between gap-x-1.5 text-[#7d84ab] cursor-pointer items-center group">
                  <button
                    type="submit"
                    onClick={handleSignOut}
                    class="flex items-center focus:outline-none focus:bg-white focus:bg-opacity-10 pl-10 pr-24 py-1.5 rounded-r-lg group-hover:text-[#dee2ec] hover:bg-opacity-10 active:scale-95"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                      />
                    </svg>

                    <span class="text-sm ml-2 tracking-wide font-thin">
                      Sign Out
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          {/* <!-- Sidebar ends -->
                    <!-- Remove class [ h-64 ] when adding a card block --> */}
          <div class="container mx-auto overflow-y-auto h-screen w-full ">
            <Header></Header>
            <div class="w-full px-6">
              <Outlet></Outlet>
            </div>
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
